import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusMacro: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFocusMacro"><Path d="M3 3H8.75V4.5H4.5V8.75H3V3Z" fill="currentColor"/><Path d="M15.25 3H21V8.75H19.5V4.5H15.25V3Z" fill="currentColor"/><Path d="M4.5 15.25V19.5H8.75V21H3V15.25H4.5Z" fill="currentColor"/><Path d="M21 15.25V21H15.25V19.5H19.5V15.25H21Z" fill="currentColor"/><Path d="M12.75 14.9193V17H11.25V14.9193C9.39935 14.5683 8 12.9423 8 10.9895V7.41463L10.4746 8.47515L12 6.94971L13.5254 8.47515L16 7.41463V10.9895C16 12.9423 14.6006 14.5683 12.75 14.9193Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFocusMacro;
